











































import { Component, Mixins, Prop } from 'vue-property-decorator';
import ShoppingCartOverviewItem from './ShoppingCartOverviewItem.vue';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import { ShoppingCartItem } from '@/entities/ShoppingCartItem';
import BaseMixin from '@/mixins/BaseMixin';
import { ShoppingCartModuleTypes } from '@/store/modules/shopping-cart';

@Component({
    components: {
        LoadingIndicator,
        ShoppingCartOverviewItem,
    },
})
export default class ShoppingCartOverviewItems extends Mixins(BaseMixin) {
    @Prop(Array)
    private cartItems!: ShoppingCartItem[];
    @Prop(String)
    private partDetailLink!: string;

    public isItemLoadingAvailability(itemId: number): boolean {
        return this.$store.getters[
            ShoppingCartModuleTypes.getters.isItemLoadingAvailability
        ](itemId);
    }
}
